import type { MissionTemplate } from '@orgus/protocol';

/** Local task form, never saved or sent to the templates module. */
export const CUSTOM_TASK: MissionTemplate = {
  id: 'onboarding-custom-task',
  title: 'Describe your own task',
  summary: 'Tell the agent what you want done.',
  icon: 'sparkles',
  missionTitle: '{description}',
  goal: '{description}',
  prompt: '',
  fields: [{ key: 'description', label: 'Task description', required: true, multiline: true }],
  mode: 'headless',
  branch: 'task/first-mission',
  tags: [],
  builtIn: true,
  createdBy: null,
  createdAt: null,
  updatedAt: null,
};
